export default "__VITE_ASSET__D9zlUm24__"